import script from "./VimeoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./VimeoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./VimeoPlayer.vue?vue&type=style&index=0&id=ea010d22&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea010d22"]])

export default __exports__